type EstimateDetailLocationState = {
  backTo?: string;
};

export function getEstimateDetailBackTarget(state: unknown) {
  const backTo = (state as EstimateDetailLocationState | null)?.backTo;
  if (typeof backTo !== "string") return "/dashboard";

  const isDashboardPath = backTo === "/dashboard" || backTo.startsWith("/dashboard?") || backTo.startsWith("/dashboard#");
  return isDashboardPath ? backTo : "/dashboard";
}
